<div *ngIf="messages?.length > 0" class="col-md-12 alert alert-success">
  <h4><div class="glyphicon glyphicon-warning-sign"></div>&nbsp;Warning Messages</h4>
  <div *ngIf="showPreamble"></div>
  <ul id="warning-list" *ngFor="let warning of messages" class="baseline-left">
    <li>{{warning.message | translate}}</li>
  </ul>
</div>
